var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"p-2",class:{
    'bg-red-500': _vm.player === 1,
    'bg-blue-500': _vm.player === 2
  }},[_c('div',{staticClass:"text-xl container mx-auto text-center text-white font-bold"},[_vm._v(" "+_vm._s(_vm.sceneName(_vm.selected))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }